// Created by hejikun on 2017/11/2 0002.
let symptom = [
  {
    path: '/symptom',
    name: '症状自查',
    component: () => import('@/pages/symptom/index')
  }
]

export default symptom
